interface ICopyToClipboardOptions {
  excludeOuterQuotes?: boolean;
  copyRaw?: boolean;
}

export const copyToClipboard = function (
  data: string,
  { excludeOuterQuotes = false, copyRaw = false }: ICopyToClipboardOptions = {},
): void {
  const el = document.createElement('textarea');
  const value = copyRaw ? data : JSON.stringify(data);
  el.value = excludeOuterQuotes && !copyRaw ? value.slice(1, -1) : value;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};
